module.exports = __webpack_public_path__ + "static/img/8.c34347e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/2/sp/8.png
// module id = 9mFe
// module chunks = 0